export enum AuthenticationType {
  NO_AUTH="NO_AUTH",
  FORM="FORM",
  API="API",
  OIDC="OIDC",
  OAUTH="OAUTH",
  GOOGLE="GOOGLE",
  JWT="JWT",
}
